import { all, fork } from "redux-saga/effects";

import { watchGetUserPosts, watchRegisterUser } from "store/sagas/authorization.saga";
import { watchGetPosts } from "store/sagas/post.saga";

export default function* root() {
  yield all([fork(watchRegisterUser), fork(watchGetPosts), fork(watchGetUserPosts)]);
}
